import { formatDate } from '@common';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Text, Tooltip } from '@mantine/core';

type ShowDateTableCellPropsType = {
  showDate: string;
  showDateInfo: string | null;
};

export const ShowDateTableCell: React.FC<ShowDateTableCellPropsType> = ({
  showDate,
  showDateInfo,
}) => {
  return (
    <Group gap="xs" wrap="nowrap">
      <Text>{formatDate(showDate)}</Text>
      {showDateInfo ? (
        <Tooltip label={showDateInfo}>
          <span>
            <FontAwesomeIcon
              icon={faCircleQuestion}
              color="var(--mantine-color-gray-6)"
              aria-label={showDateInfo}
            />
          </span>
        </Tooltip>
      ) : null}
    </Group>
  );
};
